var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReloadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Arrow-Round-Right--Streamline-Core",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Arrow Round Right Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-round-right--diagram-round-arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m9.25 0.5 2.5 2.5 -2.5 2.5",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.25 8.25c0 1.03835 -0.3079 2.0534 -0.8848 2.9167 -0.5769 0.8634 -1.3968 1.5363 -2.35611 1.9337 -0.95931 0.3973 -2.01491 0.5013 -3.03331 0.2987 -1.0184 -0.2025 -1.95386 -0.7026 -2.68809 -1.4368 -0.73422 -0.7342 -1.23424 -1.6697 -1.43681 -2.68808 -0.20257 -1.0184 -0.09861 -2.074 0.29875 -3.03331 0.39736 -0.95931 1.07027 -1.77925 1.93363 -2.35613C4.94662 3.30791 5.96165 3 7 3h4.75",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReloadIcon);
export default __webpack_public_path__ + "static/media/reload-icon.d9601fa02e2648662131d4492815a9ef.svg";
export { ForwardRef as ReactComponent };